import React, { useState, useEffect } from "react";
import { getallProcess, getAllEmployees, getAllVendors } from "../api/api";
import { toast } from "react-hot-toast";

const Page404 = () => {
  return (
    <div className=' w-full h-screen text-center'><h1>Page Not Found</h1></div>
  );
};

export default Page404;
